export const baseLogoWrapper = 'baseLogoWrapper';
export const logoTextTestId = 'logoTextTestId';

export const baseLogoText = {
  SUPPLIER: 'Supplier',
};
